import { useShippingMethodStateValue } from '../atoms/useShippingMethodState'

export const useShippingMethodsLoading = () => {
  const shippingMethodState = useShippingMethodStateValue()

  return shippingMethodState._tag === 'updating'
}
